import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import { useDayjs } from './day-js'

const dayjs = useDayjs()

export const formatDate = (v: string, format: DateFormat): string => {
  return dayjs(v, DateFormat.Default, 'en', true).format(format)
}

export const formatMainDate = (v: string): string => formatDate(v, DateFormat.MainDate)
